import {
  BasicParams,
  ParamsWithId,
  ParamsWithIds,
  BasicParamsWithContentRange,
} from './createModel';

export type ModelKeys = ReturnType<typeof createKeys>;

export function createKeys<Entity extends string>(
  entity: Entity,
  fetchKey: string = '',
  isRestV2 = false,
) {
  const entityKeys = {
    fetchKey,
    basicUrlPath: `${isRestV2 ? '/v2' : ''}/${entity}`,
    all: [entity] as const,
    byId: (id: string) => [entity, 'entity', id] as const,
    byIds: (params: ParamsWithIds) => [entity, 'byIds', params] as const,
    many: (params: BasicParams = {}) => [entity, 'many', params] as const,
    manyByContentRange: (params: BasicParamsWithContentRange) =>
      [entity, 'many', params] as const,
    entity: ({ id, ...params }: ParamsWithId) =>
      [entity, 'entity', id, params] as const,
  } as const;

  return entityKeys;
}
